import styled from 'styled-components';
import {Container} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {Input} from '../../styled/Input';

export const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%), rgba(234, 244, 252, 0.7);
  backdrop-filter: blur(100px);
`
export const NavSection = styled(Container)`
  padding: 10px 15px;
  margin-bottom: 50px;
  @media screen and (min-width: 768px) {
    padding: 30px 50px;
  }
`

export const StyledLink = styled(Link)`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 900;
  text-align: center;
  color: #1C62EF;
  line-height: 50px;
  &.NotSignedHeader{
    font-size: 42px;
  }
  &.SignedHeader{
    font-size: 24px;
  }
  &:hover{
    color: #1C62EF;
    text-decoration: none;
  }
`;

export const HeaderContainer = styled.div`
  margin-bottom: 40px;
`

export const SignUpContainer = styled.div`
  max-width: 470px;
  margin: 0 auto;
  text-align: center;
`

export const Header = styled.h1`
  font-family: Manrope, sans-serif;
  text-align: center;
  font-weight: 800;
  font-size: 42px;
  line-height: 50px;
  color: #1c62ef;
`

export const SubHeader = styled.h2`
  font-family: Manrope, sans-serif;
  text-align: center;
  font-weight: 800;
  font-size: 30px;
  line-height: 50px;
  color: #1c62ef;
`

export const CopyText = styled.p`
  font-size: 16px;
  color: #2c2b48;
  line-height: 28px;
  font-weight: 400;
  text-align: center;
  margin: 50px 0 60px;
`

export const Banner = styled.img`
  width: 100%;
`

export const StyledFormGroup = styled(Form.Group)`
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  align-items: center;
`;


export const StyledFormControl = styled(Input)`
  height: 60px;
  border-radius: 10px 0px 0px 10px;
  border-width: 0;
  color: #2C2B48;
  box-shadow: 5px 5px 5px #ccc;
  flex: 1;
  margin-right: 10px;
	
	&:focus{
		box-shadow: 5px 5px 5px #ccc;
	}
`;

export const Btn = styled(Button)`
  font-family: Manrope, sans-serif;
  font-weight: 600;
  font-size: 16px;
  background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%) ;
  border-radius: 0px 10px 10px 0px ;
  width: 86px;
  height: 60px;
  border-width: 0 ;
  box-shadow: 5px 5px 5px rgba(54, 115, 237, 0.7);
	
	&:focus{
		box-shadow: 5px 5px 5px rgb(54 115 237 / 70%);
	}
`;

export const SignInBtn = styled(Button)`
  background-color: #80abed;
  box-shadow: none;
  border: none;
  padding: 12px 50px;
  border-radius: 8px;
  &:hover{
    background-color: #80abed;
  }
`

export const ErrorText = styled.p`
  font-family: OpenSans, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: red;
  margin-top: 10px;
  text-align: left;
`

export const BtnContainer = styled.div`
  margin: 80px 0;
`

export const InviteParagraph = styled.p`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 154%;
  text-align: center;
  color: #4F5388;
  margin-bottom: 43px;
  & p{
    margin-top: 20px;
  }
`;

export const ModalBody = styled(Modal.Body)`
  padding: 64px 33px 0 33px ;
  margin-bottom: 40px;
  text-align: center;
`;

export const StyledModalBtn = styled(Button)`
  margin: 30px 0 !important;
  width: 162px;
  height: 50px;
  background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%) !important;
  border-radius: 8px !important;
  border-width: 0 !important;
`

export const HelperText = styled.p`
  font-family: OpenSans, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
  color: #3F1CEF;
  margin-top: 18px;
`

export const CloseButton = styled(Button)`
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -17px;
  right: -16px;
  border-radius: 100%;
  background: radial-gradient(100% 100% at 0% 0%, rgba(221, 227, 250, 0.99) 0%, rgba(221, 229, 250, 0.4) 100%);
`